import { Icon } from "@circle-react/components/shared/Icon";
import { IconButton } from "@circleco/compass/components/IconButton";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

export const CloseButton = ({
  onClick,
  ariaLabel,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel: string;
}) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <IconButton
        icon="cross"
        variant="outline"
        aria-label={ariaLabel}
        onClick={onClick}
      />
    );
  }
  return (
    <button
      type="button"
      className="bg-secondary focus-visible:!outline-secondary rounded-full p-[0.3562rem] leading-[1.188rem]"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <Icon
        type="20-close-sm"
        aria-hidden
        size={20}
        className="text-light hover:text-dark"
      />
    </button>
  );
};
